import React, { useRef, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button, Dropdown } from 'react-bootstrap';
import { convertTzDate, strArraySortDesc, utcToLocalDate, getSession_Json } from '../../common/app_common';
import { getApiSitesSiteHistoryCount, getApiSitesSiteHistory, getApiSitesSiteAlertStatusCount, getApiSitesSiteAlertStatus, delApiSitesSiteHistory } from '../../common/fetch_api/site';
import { getApiEdgeIdHistroyCount, getApiEdgeId, getApiEdgeIdHistroy, getApiEdgeIdAlertStatusCount, getApiEdgeIdAlertStatus, delApiEdgeIdHistroy, delApiEdgeIdAlertResolved, delApiEdgeIdAlertStatus } from '../../common/fetch_api/edge';
import { BsFillRocketTakeoffFill, BsCheckCircleFill, BsExclamationTriangle } from "react-icons/bs";
import { PageNation} from '../../common/component_common.js';
import { DecideWindow} from '../../common/modal_common.js';
import { getApiDataQuery } from '../../common/fetch_api/data';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const PAGE_PER = 10;

export const SelectEdgeModal = ({edgeInfo, result, show, handleClose}) => {

    const [edgeList, setEdgeList] = useState(null);

    useEffect(() => {        
        let apiArr = [];
        for( let edge of edgeInfo )
        {
            apiArr.push( getApiEdgeId(edge.id) );
        }

        Promise.all(apiArr)
        .then( edgeArr => {

            setEdgeList(edgeArr
                .filter(edge => edge != null)
                .map( (edge, index) =>
                    <Button key={edge.id ?? index} variant="primary" className="btn-sm mb-1" onClick={() => {onClickSelect(edge)}}>{edge.name}</Button>
                )
            );
        });

    }, []);

    const onClickSelect = (edge) => {
        closeModal();
        result(edge);
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        setEdgeList(null);
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            // backdrop="static"
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Select Edge</h6>
                <Button variant='close' className="btn-close-white" onClick={closeModal}></Button>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex flex-column'>
                    {edgeList}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export const HistoryModal = ({historyInfo, show, handleClose}) => {

    const [update, setUpdate] = useState(false);

    const [historyList, setHistoryList] = useState(null);

    const [siteSelCount, setSiteSelCount] = useState(1);
    const [curPageState, setCurPageState] = useState(1);
    const curPageRef = useRef(0);

    useEffect(() => {

        curPageRef.current.value = curPageState;

        let apiCount = null;
        let apiHistory = null;
        if(historyInfo.type === 'site')
        {
            apiCount = getApiSitesSiteHistoryCount(historyInfo.value);
            apiHistory = getApiSitesSiteHistory(historyInfo.value, PAGE_PER, curPageState);
        }
        else if(historyInfo.type === 'edge')
        {
            apiCount = getApiEdgeIdHistroyCount(historyInfo.value);
            apiHistory = getApiEdgeIdHistroy(historyInfo.value, PAGE_PER, curPageState);
        }
        
        if( apiCount && apiHistory )
        {
            Promise.resolve( apiCount )
            .then( count => {
                if( count && count.count > 0 )
                {
                    setSiteSelCount(count.count);

                    Promise.resolve( apiHistory )
                    .then( data =>
                    {
                        setHistoryList(data.map((item, index)=>
                            <div className="card" key={index}>
                                <div className="history-info">
                                    <div className="issue-date">{utcToLocalDate(convertTzDate(item.date))}</div>
                                    <div>{item.log}</div>
                                </div>
                            </div>
                        ));
                    });
                }
                else
                {
                    setHistoryList(null);
                }
            });
        }

    }, [curPageState, update]);

    const runUpdate = () => {
        setUpdate(!update);
    }

    const onClickClear = () => {
        if(historyInfo.type === 'site')
        {
            Promise.resolve( delApiSitesSiteHistory(historyInfo.value) )
            .then( done =>
            {
                setSiteSelCount(1);
                setCurPageState(1);
                curPageRef.current.value = 0;

                runUpdate();
            });
        }
        else if(historyInfo.type === 'edge')
        {
            Promise.resolve( delApiEdgeIdHistroy(historyInfo.value) )
            .then( done =>
            {
                setSiteSelCount(1);
                setCurPageState(1);
                curPageRef.current.value = 0;

                runUpdate();
            });
        }
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            // backdrop="static"
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">History</h6>
                <Button variant='close' className="btn-close-white" onClick={closeModal}></Button>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex justify-content-end my-2">
                    <Button variant='primary' className="btn-sm" onClick={onClickClear}>Clear History</Button>
                </div>
                <div className="dashboard-offcanvas">
                    <div className="history timeline">
                        <div className="outer">
                            {historyList}
                        </div>
                    </div>
                </div>
                <PageNation
                    curPageState={curPageState}
                    setCurPageState={setCurPageState}
                    selCount={siteSelCount}
                    pagePer={PAGE_PER}
                    ref={curPageRef}
                ></PageNation>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export const AlertModal = ({alertInfo, show, handleClose}) => {

    const [update, setUpdate] = useState(false);

    const [alertList, setAlertList] = useState(null);

    const [siteSelCount, setSiteSelCount] = useState(1);
    const [curPageState, setCurPageState] = useState(1);
    const curPageRef = useRef(0);

    const clearTarget = useRef('');
    const [modalDecide, setModalDecide] = useState(false);
    const closeModalDecide = () => setModalDecide(false);
    const showModalDecide = (target) => {
        clearTarget.current = target;
        setModalDecide(true);
    };

    function isClear(is)
    {
        if( is )
        {
            if( clearTarget.current === 'Resolved')
            {
                Promise.resolve( delApiEdgeIdAlertResolved(alertInfo.value) )
                .then( done =>
                {
                    setSiteSelCount(1);
                    setCurPageState(1);
                    curPageRef.current.value = 0;
        
                    runUpdate();
                });
            }
            else if( clearTarget.current === 'Alert')
            {
                Promise.resolve( delApiEdgeIdAlertStatus(alertInfo.value) )
                .then( done =>
                {
                    setSiteSelCount(1);
                    setCurPageState(1);
                    curPageRef.current.value = 0;
        
                    runUpdate();
                });              
            }
        }
    }

    const SetDecideBody = () => {
        return (
            <div className='text-center'>
                <p>Would you like to clear this?</p>
            </div>
    )};

    function firingStatus(value)
    {
        let status = '';
        if(value === 'firing')
        {
            status = <BsFillRocketTakeoffFill className="text-info" />;
        }
        else if(value === 'resolved')
        {
            status = <BsCheckCircleFill className="text-good" />;
        }

        return status;
    }

    useEffect(() => {
        
        curPageRef.current.value = curPageState;

        let apiCount = null;
        let apiStatus = null;
        if(alertInfo.type === 'site')
        {
            apiCount = getApiSitesSiteAlertStatusCount(alertInfo.value);
            apiStatus = getApiSitesSiteAlertStatus(alertInfo.value, PAGE_PER, curPageState, 'desc');
        }
        else if(alertInfo.type === 'edge')
        {
            apiCount = getApiEdgeIdAlertStatusCount(alertInfo.value, '');
            apiStatus = getApiEdgeIdAlertStatus(alertInfo.value, PAGE_PER, curPageState, '', 'desc');
        }
        
        if( apiStatus && apiCount )
        {
            Promise.resolve( apiCount )
            .then( count => {
                if( count && count.count > 0 )
                {
                    setSiteSelCount(count.count);
                    
                    Promise.resolve( apiStatus )        
                    .then( data =>
                    {
                        setAlertList(data.map((item, index)=>
                            <div className="card" key={index}>
                                <div className="history-info">
                                    <div className={`timeline-${item.severity} issue-date`}>{utcToLocalDate(convertTzDate(item.date))}</div>
                                    <div>{firingStatus(item.status)}</div>
                                    <div className={`text-${item.severity}`}>{item.labels.edgeName}</div>
                                    <div> | </div>
                                    <div className={`text-${item.severity}`}>{item.labels.summary}</div>
                                    <div> | </div>
                                    <div className={`text-${item.severity}`}>{item.labels.message}</div>
                                </div>
                            </div>
                        ));
                    });
                }
                else
                {
                    setAlertList(null);
                }
            });
        }

    }, [curPageState, update]);

    const runUpdate = () => {
        setUpdate(!update);
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            // backdrop="static"
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Alert</h6>
                <Button variant='close' className="btn-close-white" onClick={closeModal}></Button>
            </Modal.Header>
            <Modal.Body>
                {alertInfo.type === 'edge' &&
                    <div className="d-flex justify-content-end my-2">
                        <Button variant='primary' className="btn-sm me-1" onClick={() => {showModalDecide('Resolved')}}>Clear Resolved</Button>
                        <Button variant='primary' className="btn-sm" onClick={() => {showModalDecide('Alert')}}>Clear Alert</Button>
                    </div>
                }
                <div className="dashboard-offcanvas">
                    <div className="alert timeline ">
                        <div className="outer ">
                            {alertList}
                        </div>
                    </div>
                </div>
                <PageNation
                    curPageState={curPageState}
                    setCurPageState={setCurPageState}
                    selCount={siteSelCount}
                    pagePer={PAGE_PER}
                    ref={curPageRef}
                ></PageNation>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Close</Button>
            </Modal.Footer>
            {modalDecide&&<DecideWindow result={isClear} show={modalDecide} handleClose={closeModalDecide} body={<SetDecideBody/>} okButtonTxt={'Clear'}></DecideWindow>}
        </Modal>
    );
};

export const EdgeWidgetConfigModal = ({type, update, show, handleClose}) => {

    const [property, setProperty] = useState({collapse:false, height:300, 'm-agent':[], 's-agent':[], 'r-agent':[], 'rm':[]});
    const [enableItems, setEnableItems] = useState([]);   // Enable 영역 아이템 상태
    const [disableItems, setDisableItems] = useState([]);   // Disable 영역 아이템 상태

    useEffect(() => {
        const get = getSession_Json('edgeWidgetInfo');
        if( get !== null )
        {
            setProperty(get);
        }
    }, []);

    const onClickSave = () => {
        let temp = [];

        for( const item of enableItems )
        {
            temp.push(item.idx);
        }
        
        const newVal = {...property, [type]: temp };

        setProperty(newVal);
        sessionStorage.setItem('edgeWidgetInfo', JSON.stringify(newVal));
        
        closeModal();
        update();
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            // backdrop="static"
            size="lg"
            // fullscreen={true}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Widget Config</h6>
                <Button variant='close' className="btn-close-white" onClick={closeModal}></Button>
            </Modal.Header>
            <Modal.Body>
                <DragBox type={type} enableItems={enableItems} setEnableItems={setEnableItems} disableItems={disableItems} setDisableItems={setDisableItems} property={property}/>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Cancel</Button>
                <Button variant="success" className="btn-sm" onClick={onClickSave}>Save</Button>
            </Modal.Footer>
        </Modal>
    );
};

const DragBox = ({type, enableItems, setEnableItems, disableItems, setDisableItems, property}) => {
    const widgetName = {
        'm-agent':[
            { idx: 0, key: 'item_0', content: 'System', type: 'half x-lg' },
            { idx: 1, key: 'item_1', content: 'Status', type: 'full sm' },
            { idx: 2, key: 'item_2', content: 'Service Info', type: 'half x-lg' },
            { idx: 3, key: 'item_3', content: 'Module Status', type: 'half x-lg' },
            { idx: 4, key: 'item_4', content: 'Config', type: 'half x-lg' },
            { idx: 5, key: 'item_5', content: 'Software Infomation', type: 'half x-lg' },
            { idx: 6, key: 'item_6', content: 'CPU', type: 'half x-lg' },
            { idx: 7, key: 'item_7', content: 'MEM', type: 'half x-lg' },
            { idx: 8, key: 'item_8', content: 'DISK', type: 'half x-lg' },
            { idx: 9, key: 'item_9', content: 'Mux Output', type: 'half x-lg' },
            { idx: 10, key: 'item_10', content: 'LLS', type: 'half x-lg' },
        ],
        's-agent':[
            { idx: 0, key: 'item_0', content: 'Status', type: 'full md' },
            { idx: 1, key: 'item_1', content: 'Config', type: 'half x-lg' },
            { idx: 2, key: 'item_2', content: 'System Usage', type: 'half x-lg' },
            { idx: 3, key: 'item_3', content: 'Output Bitrate', type: 'half x-lg' },
            { idx: 4, key: 'item_4', content: 'Spectrum', type: 'full x-lg' },
            { idx: 5, key: 'item_5', content: 'Service', type: 'full xx-lg' },
            { idx: 6, key: 'item_6', content: 'Frame Time', type: 'full md' },
        ],
        'r-agent':[
            { idx: 0, key: 'item_0', content: 'Status', type: 'full xx-lg' },
            { idx: 1, key: 'item_1', content: 'Monitoring', type: 'full xx-lg' },
        ],
        'rm':[
            { idx: 0, key: 'item_0', content: 'STL Infomation', type: 'full xx-lg' },
            { idx: 1, key: 'item_1', content: 'STL Time Infomation', type: 'full lg' },
            { idx: 2, key: 'item_2', content: 'Tunner&GPS&Time', type: 'full x-lg' },
            { idx: 3, key: 'item_3', content: 'Output Bitrate', type: 'half x-lg' },
            { idx: 4, key: 'item_4', content: 'FEC Overhead', type: 'half x-lg' },
            { idx: 5, key: 'item_5', content: 'Error Count', type: 'half x-lg' },
            { idx: 6, key: 'item_6', content: 'Network Delay', type: 'half x-lg' },
            { idx: 7, key: 'item_7', content: 'MND', type: 'half x-lg' },
            { idx: 8, key: 'item_8', content: 'MW Bandwidth', type: 'half x-lg' },
            { idx: 9, key: 'item_9', content: 'RSSI', type: 'half x-lg' },
            { idx: 10, key: 'item_10', content: 'MER', type: 'half x-lg' },
            { idx: 11, key: 'item_11', content: 'SNR', type: 'half x-lg' },
            { idx: 12, key: 'item_12', content: 'FER', type: 'half x-lg' },
        ],
    };

    useEffect(() => {
        const widgets = widgetName[type];
        let current = property?.[type];

        if (!widgets) {
            setEnableItems([]);
            setDisableItems([]);
            return;
        }

        // 캐시 삭제 등으로 설정이 없을 때 타입별 기본값
        const defaultKeys = { 'm-agent': [0, 1], 's-agent': [0], 'r-agent': [0], 'rm': [0] };
        if (!Array.isArray(current) || current.length === 0) {
            current = defaultKeys[type] ?? [];
        }

        if (current.length > 0) {
            const enableTemp = current
                .map((idx) => widgets.find((obj) => obj.idx === idx))
                .filter(Boolean);
            const disableTemp = widgets.filter((obj) => !current.includes(obj.idx));

            setEnableItems(enableTemp);
            setDisableItems(disableTemp);
        } else {
            setEnableItems([]);
            setDisableItems(widgets);
        }
    }, [property, type]);

    // DragDropContext의 onDragEnd 핸들러
    const onDragEnd = (result) => {
        const { source, destination } = result;
        // console.log(source, destination)
        // 드래그가 끝난 위치가 없거나 시작과 끝이 같으면 종료
        if (!destination || (source.droppableId === destination.droppableId && destination.index === source.index)) {
            return;
        }

        // 이동한 아이템 객체
        const movedItem = source.droppableId === 'enable' ? enableItems[source.index] : disableItems[source.index];

        // Enable -> Disable 이동
        if (source.droppableId === 'enable' && destination.droppableId === 'disable') {
            setEnableItems(enableItems.filter((item, index) => index !== source.index));
            setDisableItems([...disableItems, movedItem]);
        }
        // Disable -> Enable 이동
        else if (source.droppableId === 'disable' && destination.droppableId === 'enable') {
            setDisableItems(disableItems.filter((item, index) => index !== source.index));
            setEnableItems([...enableItems, movedItem]);
        }
        // 다른 경우 (같은 영역에서 이동하는 경우)
        else {
            // 이동한 아이템이 있는 영역의 아이템들 배열
            const itemsArray = source.droppableId === 'enable' ? enableItems : disableItems;
            // 아이템들 배열에서 이동한 아이템 제외한 새로운 배열 생성
            const newItems = itemsArray.filter((item, index) => index !== source.index);
            // 이동한 위치에 아이템 삽입
            newItems.splice(destination.index, 0, movedItem);

            // 이동한 영역에 따라 상태 업데이트
            if (source.droppableId === 'enable') {
                setEnableItems(newItems);
            } else {
                setDisableItems(newItems);
            }
        }
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <div className="d-flex justify-content-between mt-2">
            {/* Enable 영역 */}
            <Droppable key="enable" droppableId="enable">
                {(provided) => (
                    <div className='drag-container me-2'>
                        <div className='widget-title'>Enable</div>
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className='d-flex flex-wrap drag-section enable me-2'
                        >
                            {enableItems.map((item, index) => (
                            <Draggable key={item.key} draggableId={item.key} index={index}>
                                {(provided) => (
                                    <div
                                        className={`drag-move ${item.type} edge-default`}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                    >
                                        <div className='drag-text text-white'>{item.content}</div>
                                    </div>
                                )}
                            </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    </div>
                )}
            </Droppable>
            {/* Disable 영역 */}
            <Droppable key="disable" droppableId="disable">
                {(provided) => (
                    <div className='drag-container'>
                        <div className='widget-title text-grey'>Disable</div>
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className='d-flex flex-wrap drag-section disable'
                        >
                            {disableItems.map((item, index) => (
                            <Draggable key={item.key} draggableId={item.key} index={index}>
                                {(provided) => (
                                    <div
                                    className={`drag-move ${item.type} edge-default bg-opacity-50`}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                    >
                                        <div className='drag-text text-white'>{item.content}</div>
                                    </div>
                                )}
                            </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    </div>
                )}
            </Droppable>
            </div>
        </DragDropContext>
    );
};

export const AeaModal = ({siteInfo, show, handleClose}) => {

    const [update, setUpdate] = useState(false);
    const [contents, setContents] = useState(null);
    const [imageSrc, setImageSrc] = useState('');

    useEffect(() => {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        setContents(null);
        if( siteInfo.aeaWakeUp)
        {
            setImageSrc('exclamation-triangle-warn.svg');
        }
        else
        {
            setImageSrc('exclamation-triangle-normal.svg');
        }

        for( const edge of siteInfo.edgeList )
        {
            if( edge.type === 'm-agent')
            {
                Promise.all([getApiDataQuery(`a3r_aea_count{id="${edge.id}"}`, nowTimestamp), getApiDataQuery(`a3r_aea_info{id="${edge.id}"}`, nowTimestamp)])
                .then( data =>
                {
                    const queryData = {count: data[0], info: data[1]};

                    if( queryData.count && queryData.count.data && queryData.count.data.result.length > 0 )
                    {
                        let resultArr = [];
                        for (const result of queryData.count.data.result)
                        {
                            if( result.metric )
                            {
                                for (const [key, value] of Object.entries(result.metric)) {
                                    
                                    if (key === '__name__' || key === 'exported_job' || key === 'id' || key === 'instance' || key === 'job') {
                                        continue;
                                    }

                                    resultArr.push({[key]: value});
                                }
                            }
                            resultArr.push({'value': result.value[1]});
                        }

                        let cardHtml = (
                            <div className="aea-info-list">
                                <div className="info-box">
                                    <div className='label'>{edge.name}</div>
                                    <div className='label'>a3r_aea_count</div>
                                    <div className='d-flex flex-wrap'>
                                        {
                                            resultArr.map((item, index) => {
                                                return <div key={index} className="badge normal">
                                                    {`${Object.keys(item)[0]}=${Object.values(item)[0]}`}
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        );

                        setContents(prevContents => (
                            <>
                                {prevContents}
                                {cardHtml}
                            </>
                        ));
                    }

                    if( queryData.info && queryData.info.data && queryData.info.data.result.length > 0 )
                    {
                        let resultArr = [];
                        for (const result of queryData.info.data.result)
                        {
                            if( result.metric )
                            {
                                for (const [key, value] of Object.entries(result.metric)) {
                                    
                                    if (key === '__name__' || key === 'exported_job' || key === 'id' || key === 'instance' || key === 'job') {
                                        continue;
                                    }

                                    resultArr.push({[key]: value});
                                }
                            }
                        }

                        let cardHtml = (
                            <div className="info-box">
                                <div className='label'>{edge.name}</div>
                                <div className='label'>a3r_aea_info</div>
                                <div className='d-flex flex-wrap'>
                                    {
                                        resultArr.map((item, index) => {
                                            return <div key={index} className="badge normal">
                                                {`${Object.keys(item)[0]}=${Object.values(item)[0]}`}
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                        );

                        setContents(prevContents => (
                            <>
                                {prevContents}
                                {cardHtml}
                            </>
                        ));
                    }
                });
            }
        }
    }, [update]);

    const runUpdate = () => {
        setUpdate(!update);
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            // backdrop="static"
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title"><img src={imageSrc}/> Advanced Emergency Alert</h6>
                <Button variant='close' className="btn-close-white" onClick={closeModal}></Button>
            </Modal.Header>
            <Modal.Body>
                <div className="aea-info-list">
                    {contents}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};